import React from 'react';
import PropTypes from 'prop-types';

export default function StairsIconDown({ scaleFactor = 1 }) {
  return (
   <svg
    width={32 * scaleFactor}
    height={32 * scaleFactor}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
   >
    <path
     d="M7 25L1 25L1 31L31 31L31 1L27 1L25 1L25 5L25 7L19 7L19 13L13 13L13 19L7 19L7 25Z"
     fill="#84888A"
    />
     <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 10.3026L5 11.2468L5 11.3026C5 11.4367 5.05871 11.5585 5.15428 11.6483C5.24408 11.7439 5.36587 11.8026 5.5 11.8026L5.55586 11.8026L6.5 11.8026L12.4441 11.8026C12.7511 11.8026 13 11.5788 13 11.3026L13 10.3026C13 10.0265 12.7511 9.80261 12.4441 9.80261L8.31354 9.80261L15.5888 2.52735C15.7691 2.3471 15.7551 2.04447 15.5577 1.8514L14.8428 1.15221C14.6453 0.959132 14.3392 0.948728 14.1589 1.12897L7 8.2879L7 4.35847C7 4.05148 6.77614 3.80261 6.5 3.80261L5.5 3.80261C5.22386 3.80261 5 4.05148 5 4.35847L5 10.3026Z"
      fill="#84888A"
     />
   </svg>
  );
}

StairsIconDown.propTypes = {
 scaleFactor: PropTypes.number,
};
